angular.module('core')
    .component('singularPlural', {
        bindings: {
            value: '<',
            sin: '@',
            plu: '@'
        },
        template: `<span>{{$ctrl.value}}&nbsp;{{$ctrl.isSingular ? ($ctrl.sin | translate) : ($ctrl.plu | translate)}}</span>`,
        controller: function () {
            this.$onChanges = () => {
                this.isSingular = this.value === 1;
            }
        }
    })
